import React, { PureComponent } from 'react';
import request from 'axios';
import { getAdminAuthHeader, beginImpersonation, endImpersonation } from '../../client/token';

// Sticky bar shown while the admin impersonates a user (detected via the
// stashed admin token in localStorage). Lets the admin jump straight to
// another user or return to the admin dashboard. All requests here use the
// ADMIN token, not the impersonated user's.
class AdminImpersonationBanner extends PureComponent {
    constructor(props) {
        super(props);
        this.backToAdmin = this.backToAdmin.bind(this);
        this.switchUser = this.switchUser.bind(this);
        this.state = {
            users: undefined,
            switching: false,
        };
    }

    async componentDidMount() {
        try {
            const result = await request.get('/api/v1/admin/users', getAdminAuthHeader());
            // Demo accounts (temporary and coupon based) are throwaway: keep them out of the switcher.
            const isDemo = u => (u['$Subscription$'] && u['$Subscription$'].demo) || (u.Email || '').startsWith('_demo_');
            this.setState({ users: result.data.users.filter(u => !isDemo(u)) });
        } catch (error) {
            // Stashed admin token expired — drop back to the login screen
            // rather than leaving a broken switcher around.
            console.error(new Error().stack, error);
        }
    }

    backToAdmin(evt) {
        if (evt) {
            evt.preventDefault();
        }

        endImpersonation();
        window.location.assign('/admin');
    }

    async switchUser(evt) {
        const id = parseInt(evt.target.value);
        if (!id) {
            return;
        }

        this.setState({ switching: true });
        try {
            const result = await request.post('/api/v1/user/employee/impersonate', { id }, getAdminAuthHeader());
            beginImpersonation(result.data.token);
            window.location.assign('/case/all');
        } catch (error) {
            console.error(new Error().stack, error);
            this.setState({ switching: false });
        }
    }

    render() {
        const user = this.props.user;
        if (!user) {
            return null;
        }

        const users = this.state.users || [];
        const owners = users.filter(u => u.owner_id === 0 && !u.deleted_at).sort((a, b) => a.id - b.id);
        const options = [];
        owners.forEach(owner => {
            options.push(
                <option key={owner.id} value={owner.id} disabled={owner.id === user.id}>
                    {`${owner['FirstName'] || ''} ${owner['LastName'] || ''}`.trim()} ({owner['Email']}){owner['CompanyName'] ? ` — ${owner['CompanyName']}` : ''}
                </option>
            );

            users.filter(u => u.owner_id === owner.id && !u.deleted_at)
                 .sort((a, b) => a.id - b.id)
                 .forEach(employee => {
                     options.push(
                         <option key={employee.id} value={employee.id} disabled={employee.id === user.id}>
                             {`   ↳ ${`${employee['FirstName'] || ''} ${employee['LastName'] || ''}`.trim()} (${employee['Email']})`}
                         </option>
                     );
                 });
        });

        return (
            <div style={{
                background: '#d9534f',
                color: '#fff',
                textAlign: 'center',
                padding: '6px 12px',
                fontSize: '13px',
            }}>
                <span style={{ marginRight: 12 }}>
                    Admin: impersonating <strong>{`${user['FirstName'] || ''} ${user['LastName'] || ''}`.trim()}</strong> ({user['Email']})
                </span>
                <select value=""
                        disabled={this.state.switching || !this.state.users}
                        onChange={this.switchUser}
                        style={{ color: '#333', maxWidth: 300, marginRight: 12 }}>
                    <option value="">{this.state.switching ? 'Switching…' : 'Switch to user…'}</option>
                    {options}
                </select>
                <a href="/admin"
                   onClick={this.backToAdmin}
                   style={{ color: '#fff', textDecoration: 'underline', fontWeight: 'bold' }}>
                    Back to Admin
                </a>
            </div>
        );
    }
}

export default AdminImpersonationBanner;
